import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { Box, Grid, Typography } from '@mui/material';
import CustomDialog from '../commoncomponents/CustomDialog';
import dayjs from "dayjs";
import { useDispatch, useSelector } from 'react-redux';
import { getAuthToken, getCreatedBy } from '../../utility/tokenUtility';
import { DefaultCard } from '../../assets/styled-components/card';
import CustomDateTimePicker from '../commoncomponents/CustomDateTimePicker';
import CustomTextArea from '../commoncomponents/CustomTextArea';
import PageLoader from '../commoncomponents/PageLoader';
import RoutineInspectionRespondedDetailsEditForm from './RoutineInspectionRespondedDetailsEditForm';
import RoutineInspectionOtherRespondedDetailsForm from './RoutineInspectionOtherRespondedDetailsForm';
import RoutineInspectionRepairTrackerEditForm from './RoutineInspectionRepairTrackerEditForm';
import RoutineInspectionPartReplacementEditForm from './RoutineInspectionPartReplacementEditForm.';
import RoutineInspectionBottomButtonForVendorForm from './RoutineInspectionBottomButtonForVendorForm';
import riRepository from '../../api/repositories/riRepository';
import { routineInspectionAddRepairTrackerForVendor, routineInspectionCheckFormSubmitForVendor, routineInspectionClearRepairTrackerForVendor, routineInspectionUpdateCompletionInfoDetails, routineInspectionUpdateothereRespondedDetails } from '../../redux/actions/vendor/routineInspectionWebFormActions';
import { useLocation } from 'react-router-dom';
import BottomButtonForVendor from '../vendordashboard/BottomButtonForVendor';
import { statusList } from '../../utility/message';

const RoutineInspectionVendorWorkOrderEditForm = ({ setPage, buttonAttributes, page, locationState }) => {
    
    const location = useLocation();
    
    const createdBy = getCreatedBy('createdBy');
    const token = getAuthToken("id_token");
    const [responseData, setResponseData] = useState(null);
    const webFormData = useSelector((state) => state.routineInspectionVendorWebForm);
    const [otherDetails, setOtherDetails] = useState(webFormData?.otherRespondedDeatils);
    const [repairTrackerRows, setRepairTrackerRows] = useState(webFormData?.repairTracker);
    const [partReplacementRows,setPartReplacementRows] = useState(webFormData?.partReplacementRows)
    const [openDialog, setOpenDialog] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const dispatch = useDispatch();
    const [completionData, setCompletionData] = useState(webFormData?.completionDetails);
    const [error, setError] = useState({
        actionTaken: false,
        startDateandTime:false,
        endDateandTime:false,
        repairTrackerRows:false,
        outsourceRespondRemarks:false
    });
    const [errorMessage, setErrorMessage] = useState({
        actionTaken: "",
        startDateandTime:"",
        endDateandTime:"",
        repairTrackerRows:"",
        outsourceRespondRemarks:""
    });

    const workOrderId = locationState?.workorderId || "";
    const assetCategroyType = locationState?.serviceType || "";
    const categoryType = locationState?.categoryType || "";
    const serviceType = assetCategroyType === "FEMS" ? "fem" : "bem";
    const getRepairTrackerRows = webFormData?.repairTracker || [];
    const getstatusId = assetCategroyType === "FEMS" ? location?.state?.femworkorderstatusId : location?.state?.bemworkorderstatusId;
    const checkstatus = [statusList?.completed?.id,statusList?.closed?.id,statusList?.verified?.id,statusList?.completedOutsource?.id].includes(getstatusId) ? true : false;

    const handleOnchange = (value, name,) => {
        setCompletionData((previous) => {
            const updatedData = {
                ...previous,
                [name]: value,
            };

           

            return updatedData;
        });

        if (name === 'actionTaken' && value.trim()) {
            setError((prevError) => ({ ...prevError, actionTaken: false }));
            setErrorMessage((prevMessage) => ({ ...prevMessage, actionTaken: "" }));
        }

        let workorderDateandTime = responseData?.[0]?.[`${serviceType}routineinspectionheaderId`]?.[0]?.workorderdate || ''
        const workOrderDateAndTime = new Date(workorderDateandTime);
        const selectedDate = new Date(value);
        const currentDate = new Date();
        const endDate = new Date(completionData?.endDateandTime);
    
        if (name === 'startDateandTime' && value) {
    
          if (selectedDate < workOrderDateAndTime || selectedDate > currentDate) {
            setError((prevErrors) => ({
              ...prevErrors,
              startDateandTime: true,
            }));
            setErrorMessage((prevErrorMessages) => ({
              ...prevErrorMessages,
              startDateandTime: "Start date and time should be between Work Order date and current date/time.",
            }));
          } else {
            setError((prevErrors) => ({
              ...prevErrors,
              startDateandTime: false,
            }));
            setErrorMessage((prevErrorMessages) => ({
              ...prevErrorMessages,
              startDateandTime: "",
            }));
          }
    
          if (endDate && selectedDate) {
            if (selectedDate >= endDate) {
              setError((prevErrors) => ({
                ...prevErrors,
                endDateandTime: true,
              }));
              setErrorMessage((prevErrorMessages) => ({
                ...prevErrorMessages,
                endDateandTime: "End date and time should be on the same day and greater than the start time.",
              }));
            } else {
              setError((prevErrors) => ({
                ...prevErrors,
                endDateandTime: false,
              }));
              setErrorMessage((prevErrorMessages) => ({
                ...prevErrorMessages,
                endDateandTime: "",
              }));
            }
          };
        };
    
        if (name === 'endDateandTime' && value) {
          const selectedEndDateTime = new Date(value);
          const startDateTime = new Date(completionData?.startDateandTime);
          if (
            selectedEndDateTime.toDateString() !== startDateTime.toDateString() || // If the dates are not the same
            selectedEndDateTime < startDateTime ||
            selectedEndDateTime > currentDate
          ) {
            setError((prevErrors) => ({
              ...prevErrors,
              endDateandTime: true,
            }));
            setErrorMessage((prevErrorMessages) => ({
              ...prevErrorMessages,
              endDateandTime: "End date and time should be on the same day and greater than the start time.",
            }));
          } else {
            setError((prevErrors) => ({
              ...prevErrors,
              endDateandTime: false,
            }));
            setErrorMessage((prevErrorMessages) => ({
              ...prevErrorMessages,
              endDateandTime: "",
            }));
          };
        };


    };

    useEffect(() => {
        const fetchData = async () => {
            setIsLoading(true);
            if (workOrderId) {

                const response = await riRepository.getWorkOrderSummary(serviceType, workOrderId);
                setResponseData(response);
                const updateCompletionData = {
                    completionId: response?.[0]?.[`${serviceType}routineinspectionheaders`]?.[0]?.[`${serviceType}routineinspectcompletiondetails`]?.[0]?.id || "",
                    // startDateandTime: response?.[0]?.[`${serviceType}routineinspectionheaders`]?.[0]?.[`${serviceType}routineinspectcompletiondetails`]?.[0]?.startdate || dayjs().format("YYYY-MM-DDTHH:mm:ss"),
                    // endDateandTime: response?.[0]?.[`${serviceType}routineinspectionheaders`]?.[0]?.[`${serviceType}routineinspectcompletiondetails`]?.[0]?.enddate || dayjs().format("YYYY-MM-DDTHH:mm:ss"),
                    actionTaken: response?.[0]?.[`${serviceType}routineinspectionheaders`]?.[0]?.[`${serviceType}routineinspectcompletiondetails`]?.[0]?.actiontaken || "",
                    timeStamp: response?.[0]?.[`${serviceType}routineinspectionheaders`]?.[0]?.[`${serviceType}routineinspectcompletiondetails`]?.[0]?.timestamp || ""
                };
                setCompletionData(updateCompletionData);
                dispatch(routineInspectionUpdateCompletionInfoDetails("ROUTINEINSPECTION_UPDATE_COMPLETION_DETAILS", updateCompletionData));
            }
            setIsLoading(false);
        };
        fetchData();
    }, [serviceType, workOrderId]);
    

    const handleSaveClick = useCallback(async (event) => {
        event.preventDefault();

        let hasError = false;

        if(!(locationState?.isViewMode || checkstatus)){
            if (!completionData?.actionTaken.trim()) {
                setError((prevError) => ({ ...prevError, actionTaken: true }));
                setErrorMessage((prevMessage) => ({ ...prevMessage, actionTaken: "Action Taken is required." }));
                hasError = true;
            } else if (!otherDetails?.outsourceRespondRemarks.trim()) {
                setError((prevError) => ({ ...prevError, outsourceRespondRemarks: true }));
                setErrorMessage((prevMessage) => ({ ...prevMessage, outsourceRespondRemarks: "Outsource Respond Remarks is required." }));
                hasError = true;
            }
            if(error?.startDateandTime || error?.endDateandTime || error?.outsourceRespondRemarks){
                hasError = true;
            }
    
            if (repairTrackerRows <= 0) {
                setError((prev) => ({
                  ...prev,
                  repairTrackerRows: true,
                }));
                setErrorMessage((prev) => ({
                  ...prev,
                  repairTrackerRows: "Please add at least one repair tracker row.",
                }));
                hasError = true;
              } 
    
            if (hasError) {
                return;
            }
    
        };
        
        const sendTheStatusID = locationState?.woStatus === 3 ?  10 : locationState?.woStatus; // 3 means status (In_Progress) to send the 10 means WOrkorderStatus ID (In-Progress_Outsource)
        const sendCategoryID =  2 ; //Send the Category ID that is Scheduled Workorder for RI
        const sendProcessingPercentage = 32; // For 32 means processPercentage for Assements Tab in vendorFlow

        if(!(locationState?.isViewMode)){
            const assessmentsPayload = {
                assessmentId: otherDetails.assessmentId || "",
                ispartsrequired: otherDetails.selectedPartsRequired
                    ? (otherDetails.selectedPartsRequired === "yes" ? true : false)
                    : "",
                isassettakenoutlocation: otherDetails.selectedAssetTakenOut
                    ? (otherDetails.selectedAssetTakenOut === "yes" ? true : false)
                    : "",
                respondremarks: otherDetails?.outsourceRespondRemarks,
                category: sendCategoryID,
                workorderheaderId: workOrderId || "",
                workorderstatusId:  sendTheStatusID,
                processingpercentage: sendProcessingPercentage,
                respondfinding:otherDetails?.respondFinding || ""
            };

            const API_Payload = {
                respondedbyid:webFormData?.respondedDetails?.respondedByID || "",
                responsestartdate: webFormData?.respondedDetails?.respondedStartDateandTime || "",
                responseenddate: webFormData?.respondedDetails?.respondedEndDateandTime || "",
                assessmenthrs: "",
                respondedByName: "",
                respondfinding: otherDetails?.respondFinding || "",
                ispartsrequired:  otherDetails.selectedPartsRequired ? (otherDetails.selectedPartsRequired === "yes" ? true : false) : "",
                isassettakenoutlocation: otherDetails.selectedAssetTakenOut ? (otherDetails.selectedAssetTakenOut === "yes" ? true : false) : "",
                vendorid: webFormData?.respondedDetails?.vendorID || "",
                Respondremarks: otherDetails?.outsourceRespondRemarks || "",
                [`${serviceType}routineinspectionheaderId`]: workOrderId || "",
                [`${serviceType}taskdetailsId`]: webFormData?.respondedDetails?.taskCodeID || "",
                [`${serviceType}worespondtypeId`]: webFormData?.respondedDetails?.repairTypeID || "",
              };
    
            
            
            const UpdateCompletionPayload = {
                startdate: completionData?.startDateandTime || "",
                enddate: completionData?.endDateandTime || "",
                actiontaken: completionData?.actionTaken || "",
                [`${serviceType}routineinspectionheaderId`]: workOrderId || "",
                isassetreqnotavail: completionData?.isassetreqnotavail || false,
                id: completionData?.completionId || "",
                timestamp: completionData?.timeStamp || ""
            };
    
            const employeeName = await riRepository.fetchEmployeeDetails();
            const lovOptions = await riRepository.lovOptions();
            const mapEmpCode = (id) => {
                const empCode = employeeName?.find(empc => empc.id === id);
                return empCode ? empCode.employeecode : '';
            };
    
            const mapEmpName = (id) => {
                const empCode = employeeName?.find(empN => empN.id === id);
                return empCode ? empCode.employeename : '';
            };
    
            const mapFlagDesc = (id) => {
                const flagDesc = lovOptions?.femuschworepairflags?.find(desc => desc?.id === id);
                return flagDesc ? flagDesc?.repairflag : '';
            };
            
            const mapPicDesc = (id) => {
                const picDesc = lovOptions?.femuschworepairpics?.find(desc => desc?.id === id);
                return picDesc ? picDesc?.repairpic : '';
            };
    
            const mapActivityDesc = (id) => {
                const activityDesc = lovOptions?.femuschworepairactivities?.find(desc => desc?.id === id);
                return activityDesc ? activityDesc?.repairactivity : '';
            };
    
                const updatePayload = partReplacementRows?.map((row) => ({
                itemcodeid: row?.itemPartCode?.id || "",
                quantityused: row?.quantity,
                partscost: row?.partCost,
                [`${serviceType}routineinspectionheaderId`]: row?.[`${serviceType}routineinspectionheaderId`],
                createdby: createdBy,
                [`${serviceType}routineinspectionheaderId`]: workOrderId,
                id: row?.id || "",
                timestamp: row?.timeStamp || ""
            }));
    
            try {
                let assessmentsResponse = [];
                if(otherDetails?.assessmentId){
                    assessmentsResponse = await riRepository.updateRIAssessmentsDetailsInWebForm(serviceType,assessmentsPayload);
                } else {
                    assessmentsResponse = await riRepository.addAssessmentsDetails(serviceType,API_Payload)
                };
    
                const updaterRepairDetailsPayload = repairTrackerRows?.map((row) => ({
                    employeeid: row?.employeename?.id || "",
                    Vendortechnician: row?.technician || "",
                    repairstartdate: row?.startDateandTime || "",
                    repairenddate: row?.endDateandTime || "",
                    repairduration: row?.repairDuration || "",
                    preparationhours: row?.preparationHours || "",
                    verificationhours: row?.verificationHours || "",
                    remarks: row?.remarks || "",
                    [`${serviceType}routineinspectionheaderId`]: workOrderId || "",
                    [`${serviceType}routineinspectassesmentheaderId`]: assessmentsResponse?.id || otherDetails?.assessmentId || "",
                    [`${serviceType}uschworepairflagId`]: row?.flag?.id || "",
                    [`${serviceType}uschworepairpicId`]: row?.pic?.id || "",
                    [`${serviceType}uschworepairactivityId`]: row?.activity?.id || "",
                    [`${serviceType}routineinspectcompletiondetails`]: [],
                    createdby: createdBy,
                    id: row?.id || "",
                    timestamp: row?.timeStamp || ""
                }));

                const saveRepairTracker = await riRepository.updateRepairTracker(serviceType, updaterRepairDetailsPayload, categoryType, otherDetails?.assessmentId);
                dispatch(routineInspectionClearRepairTrackerForVendor("ROUTINEINSPECTION_CLEAR_REPAIR_TRACKER_FOR_VENDOR", []));
                saveRepairTracker?.forEach((row) => {
                    const transformedObject = {
                        employeename: {
                            employeeCode: mapEmpCode(row?.employeeid || ""),
                            employeename: mapEmpName(row?.employeeid || ""),
                            id: row?.employeeid || "",
                        },
                        technician: row?.vendortechnician || "",
                        flag: {
                            id: row?.[`${serviceType}uschworepairflagId`] || "",
                            label: mapFlagDesc(row?.[`${serviceType}uschworepairflagId`] || "")
                        },
                        pic: {
                            id: row?.[`${serviceType}uschworepairpicId`] || "",
                            label: mapPicDesc(row?.[`${serviceType}uschworepairpicId`] || "")
                        },
                        activity: {
                            id: row?.[`${serviceType}uschworepairactivityId`] || "",
                            label: mapActivityDesc(row?.[`${serviceType}uschworepairactivityId`] || "")
                        },
                        startDateandTime: row?.repairstartdate || "",
                        endDateandTime: row?.repairenddate || "",
                        repairDuration: row?.repairduration || "",
                        preparationHours: row?.preparationhours || "",
                        verificationHours: row?.verificationhours || "",
                        remarks: row?.remarks || "",
                        id: row?.id || "",
                        timeStamp: row?.timestamp || ""
                    };
                    
                    dispatch(routineInspectionAddRepairTrackerForVendor("ROUTINEINSPECTION_ADD_REPAIR_TRACKER_DETAILS_FOR_VENDOR", transformedObject));
                });
    
                if (updatePayload?.length > 0) {
                    
                            const addItemPartCode = await riRepository.updateItemPartCode(serviceType, updatePayload, workOrderId, categoryType);
                            dispatch({ type: "ROUTINEINSPECTION_CLEAR_PART_REPLACEMENT_FOR_VENDOR", payload: [] });
                            const itemCodeResponse = await riRepository.fetchItemCodeoptions(serviceType, categoryType);
                            const mapItemCode = (id) => {
                                const ic = itemCodeResponse.find(ic => ic.id === id);
                                return ic ? ic.itemcode : '';
                            };
                
                            const mapItemDesc = (id) => {
                                const ic = itemCodeResponse.find(ic => ic.id === id);
                                return ic ? ic.descriptionname : '';
                            };
                
                            addItemPartCode?.forEach((row) => {
                                const transformedObject = {
                                    itemDescription: mapItemDesc(row?.itemcodeid || ""),
                                    itemPartCode: {
                                        id: row?.itemcodeid || "",
                                        label: mapItemCode(row?.itemcodeid || "")
                                    },
                                    partCost: row?.partscost || 0,
                                    quantity: row?.quantityused || 0,
                                    id: row?.id || "",
                                };
                
                                dispatch({ type: "ROUTINEINSPECTION_PART_REPLACEMENT_FOR_VENDOR", payload: transformedObject });
                            });
                        };
    
                if (completionData?.completionId) {
                    const updCompletionInfo = await riRepository.updateCompletionInfo(serviceType, completionData?.completionId, UpdateCompletionPayload, categoryType);
                    dispatch(routineInspectionUpdateCompletionInfoDetails("ROUTINEINSPECTION_UPDATE_COMPLETION_DETAILS", { ...completionData, completionId: updCompletionInfo?.id, timeStamp: updCompletionInfo?.timestamp || "" }));
    
                } else {
                    const saveCompletionInfo = await riRepository.addCompletionInfo(serviceType, UpdateCompletionPayload, categoryType);
                    await riRepository.workorderStatusValue(serviceType, workOrderId, sendTheStatusID,sendProcessingPercentage);
                    dispatch(routineInspectionUpdateCompletionInfoDetails("ROUTINEINSPECTION_UPDATE_COMPLETION_DETAILS", { ...completionData, completionId: saveCompletionInfo?.id, timeStamp: saveCompletionInfo?.timestamp || "" }));
                    dispatch(routineInspectionCheckFormSubmitForVendor("UPDATE_FORMSUBMIT_STATUS", statusList?.inProgressOutsource?.id));

                };
                dispatch(routineInspectionUpdateothereRespondedDetails("ROUTINEINSPECTION_UPDATE_OTHER_RESPONDED_DETAILS", otherDetails));
    
    
            } catch (error) {
                console.error('Error saving data:', error);
            }
        }
        
        setPage('Attachments & Signature');
    }, [repairTrackerRows, otherDetails, workOrderId, completionData]);

    useEffect(() => {

        const loadData = async () => {
            setIsLoading(true);
            // Update states
            setRepairTrackerRows(webFormData?.repairTracker);
            setOtherDetails(webFormData?.otherRespondedDeatils || otherDetails);
            setPartReplacementRows(webFormData?.partReplacementRows);

            if (webFormData?.repairTracker?.length > 0) {
                setError((prev) => ({
                    ...prev,
                    repairTrackerRows: false,
                }));

                setErrorMessage((prev) => ({
                    ...prev,
                    repairTrackerRows: ""
                }));
            }
            setIsLoading(false);
        };

        loadData();
        if(getRepairTrackerRows?.length > 0){
            let getFirstIndexofStartDateTime;
            let getLastIndexofEndDateTime;
    
            if (getRepairTrackerRows?.length === 1) {
                getFirstIndexofStartDateTime = getRepairTrackerRows[0]?.startDateandTime || "";
                getLastIndexofEndDateTime = getRepairTrackerRows[0]?.endDateandTime || "";
            } else if (getRepairTrackerRows?.length > 1) {
                getFirstIndexofStartDateTime = getRepairTrackerRows?.reduce((earliest, current) => {
                return new Date(earliest?.startDateandTime) < new Date(current?.startDateandTime) ? earliest : current;
                })?.startDateandTime || "";
                // Find the row with the greatest endDateandTime
                getLastIndexofEndDateTime = getRepairTrackerRows.reduce((latest, current) => {
                return new Date(latest?.endDateandTime) > new Date(current?.endDateandTime) ? latest : current;
                })?.endDateandTime || "";
            
                getLastIndexofEndDateTime = getLastIndexofEndDateTime || "";
            };
            
            setCompletionData((prev)=>({
                ...prev,
                startDateandTime: getFirstIndexofStartDateTime || dayjs().format("YYYY-MM-DDTHH:mm:ss"),
                endDateandTime: getLastIndexofEndDateTime || dayjs().format("YYYY-MM-DDTHH:mm:ss")
            }));
        };

    }, [webFormData,getRepairTrackerRows,completionData?.startDateandTime,completionData?.endDateandTime]);


    useMemo(()=>{
            if(otherDetails?.outsourceRespondRemarks){
                setError((prev)=>({
                    ...prev,
                    outsourceRespondRemarks:false
                }));
    
                setErrorMessage((prev)=>({
                    ...prev,
                    outsourceRespondRemarks:""
                }));
            }
    
        },[otherDetails?.outsourceRespondRemarks])

    const handleCloseSuccessDialog = () => {
        setOpenDialog(false);
    };
    
    return (
        <>
            <PageLoader open={isLoading} />
            <form onSubmit={handleSaveClick} noValidate >
                <RoutineInspectionRespondedDetailsEditForm 
                    locationState={locationState} 
                    responseData={responseData?.[0]} 
                />
                <Box mb={2} />

                <RoutineInspectionOtherRespondedDetailsForm
                    locationState={locationState}
                    responseData={responseData?.[0]}
                    onOtherDetailsChange={setOtherDetails}
                    errorState={error?.outsourceRespondRemarks}
                    errorMesaage={errorMessage?.outsourceRespondRemarks || ""}
                />
                <Box mb={2} />
                <DefaultCard>
                {error?.repairTrackerRows && (
                        <Typography component={"span"} color={"error"}>
                            {errorMessage?.repairTrackerRows}*
                        </Typography>
                    )}
                <RoutineInspectionRepairTrackerEditForm
                    locationState={locationState}
                    responseData={responseData?.[0]}
                />
                </DefaultCard>
                
                <Box mb={2} />

                <DefaultCard>
                    <Box >
                        <Typography variant='title2' gutterBottom>
                            Completion Info
                        </Typography>
                        <Box mb={3} />
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={6}>
                                <CustomDateTimePicker
                                    label="Start Date and Time"
                                    onDateChange={(date) => handleOnchange(date, 'startDateandTime')}
                                    value={completionData?.startDateandTime || dayjs().format("YYYY-MM-DDTHH:mm:ss")}
                                    error={error?.startDateandTime}
                                    helperText={errorMessage?.startDateandTime || ""}
                                    disabled={(getRepairTrackerRows?.length) > 0 ? true : (locationState?.isViewMode || checkstatus)}

                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <CustomDateTimePicker
                                    label="End Date and Time"
                                    onDateChange={(date) => handleOnchange(date, 'endDateandTime')}
                                    value={completionData?.endDateandTime || dayjs().format("YYYY-MM-DDTHH:mm:ss")}
                                    error={error?.endDateandTime}
                                    helperText={errorMessage?.endDateandTime || ""}
                                    disabled={(getRepairTrackerRows?.length) > 0 ? true : (locationState?.isViewMode || checkstatus)}

                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <CustomTextArea
                                    label="Action Taken"
                                    id="actionTaken"
                                    name="actionTaken"
                                    onChange={(e) => handleOnchange(e, "actionTaken")}
                                    value={completionData?.actionTaken || ''}
                                    error={error?.actionTaken}
                                    helperText={errorMessage?.actionTaken}
                                    isMandatoryField={true}
                                    disabled={locationState?.isViewMode || checkstatus}
                                />
                            </Grid>
                        </Grid>
                    </Box>
                </DefaultCard>
                {locationState?.bottomButtons && <BottomButtonForVendor page={page} buttonAttributes={buttonAttributes} />}
                {!locationState?.bottomButtons && <RoutineInspectionBottomButtonForVendorForm page={page} buttonAttributes={buttonAttributes} />}

                <CustomDialog
                    open={openDialog}
                    onClose={handleCloseSuccessDialog}
                    title="Success"
                    confirmBtn="Ok"
                    content="Data updated successfully."
                />
            </form>
        </>
    );
};

export default RoutineInspectionVendorWorkOrderEditForm;
